import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSpotlight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSpotlight"><Path fillRule="evenodd" clipRule="evenodd" d="M22.4141 9L19.4141 12L22.4141 15L15 22.4141L12 19.4141L9 22.4141L1.58594 15L4.58594 12L1.58594 9L9 1.58594L12 4.58594L15 1.58594L22.4141 9ZM7.41406 12L12 16.5859L16.5859 12L12 7.41406L7.41406 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSpotlight;
